enum calculationTypeId {
  CUSTOM_DK = 0,
}

export default calculationTypeId;
